// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import './ConsoleOutput.less';

/**
 * ConsoleOutput component.
 */
const ConsoleOutput = ({ baseClassName, className, wide, cursor, children, ...props }) => (
    <pre
        className={classNames(
            baseClassName,
            {
                [`${baseClassName}--wide`]: wide,
            },
            className,
        )}
        {...props}
    >
        {children}
        {cursor ? <span className={classNames(`${baseClassName}__cursor`, 'animation-blink')} /> : null}
    </pre>
);
ConsoleOutput.propTypes = {
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * Console output content
     */
    children: PropTypes.node,
    /**
     * Enable wide mode
     */
    wide: PropTypes.bool,
    /**
     * Enable cursor
     */
    cursor: PropTypes.bool,
};
ConsoleOutput.defaultProps = {
    baseClassName: `${CLS_PREFIX}console-output`,
    className: null,
    children: null,
    wide: false,
    cursor: false,
};

export default ConsoleOutput;



// WEBPACK FOOTER //
// ./components/ConsoleOutput/ConsoleOutput.js